import { I18n } from '@aws-amplify/core';
import { Col, Form, Row, message } from 'antd';

import { useUpdateActionPlan } from '@/hooks/v2/useUpdateActionPlan';
import * as S from '../styles';

const { useFormInstance } = Form;

interface FooterProps {
	onClose(): void;
	actionPlan: any;
	formName: string[];
	activityId?: string;
}

export function Footer({ formName, onClose, actionPlan, activityId }: Readonly<FooterProps>) {
	const form = useFormInstance();
	const { mutateAsync: updateActionPlan } = useUpdateActionPlan();

	const fieldName = formName[0];

	async function handleOnSubmit(): Promise<void> {
		try {
			const formValues = await form.validateFields();
			const values = formValues[fieldName][actionPlan.id];

			const payload = {
				id: actionPlan.id,
				status: actionPlan.status,
				due_date: values.due_date,
				priority: values.priority,
				title: values.action_plan_name,
				description: values.description,
				activity_id: activityId,
				company_id: actionPlan.company.id,
				organization_id: actionPlan.organization.id,
				investment_range: values.investment_range,
				investment_value: actionPlan.investment_value,
				responsible_user_id: values.responsible_id
			};

			await updateActionPlan(payload);
			onClose();
		} catch (error: any) {
			const errorMessage = error?.response?.data.message || error.message;
			message.error(I18n.get(errorMessage));
		}
	}

	return (
		<Row justify="center" gutter={[12, 0]}>
			<Col>
				<S.SecondaryButton onClick={onClose}>{I18n.get('Cancel')}</S.SecondaryButton>
			</Col>
			<Col>
				<S.PrimaryButton type="primary" onClick={handleOnSubmit}>
					{I18n.get('Save')}
				</S.PrimaryButton>
			</Col>
		</Row>
	);
}
